/* SNKRR cart sync + round-trip auto-sizing.
   - Keeps the cart drawer + cart-icon bubble in sync no matter how an item was added.
   - Auto-adds and sizes the Round-Trip Shipping tier to match the pair count
     (each Cleaning Service line = 1 pair); removes it when no service remains.
   build:v2026-07-03b */
(function () {
  'use strict';

  // Round-trip tier variant IDs by pair count (5 = 5 or more pairs).
  var RT_TIERS = { 1: 51395923148964, 2: 51395923181732, 3: 51395923214500, 4: 51395923247268, 5: 51395923280036 };
  var RT_IDS = [51395923148964, 51395923181732, 51395923214500, 51395923247268, 51395923280036];

  var origFetch = (window.fetch && window.fetch.bind(window)) || null;
  var pending = null;
  var working = false;

  function raw(url, opts) { return (origFetch || window.fetch)(url, opts); }
  function sectionUrl(s) {
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root + '?section_id=' + s;
  }
  function pairCount(cart) {
    return (cart.items || []).filter(function (i) {
      return (i.product_type || '').toLowerCase() === 'cleaning service' && String(i.handle || '').indexOf('sneaker-cleaning-') === 0;
    }).reduce(function (s, i) { return s + (i.quantity || 0); }, 0);
  }
  function wantedTier(pairs) { return pairs > 0 ? RT_TIERS[Math.min(pairs, 5)] : null; }

  // Ensure the cart holds exactly the correct round-trip tier (or none). Uses the
  // original (unpatched) fetch so its own writes don't re-trigger the watcher.
  function reconcile() {
    return raw('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var wanted = wantedTier(pairCount(cart));
        var rt = (cart.items || []).filter(function (i) { return RT_IDS.indexOf(i.variant_id) !== -1; });
        var correct = wanted
          ? (rt.length === 1 && rt[0].variant_id === wanted && rt[0].quantity === 1)
          : (rt.length === 0);
        if (correct) return false;
        var updates = {};
        RT_IDS.forEach(function (v) { updates[v] = 0; });
        return raw('/cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates: updates })
        }).then(function () {
          if (!wanted) return true;
          return raw('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: wanted, quantity: 1 }] })
          }).then(function () { return true; });
        });
      })
      .catch(function () { return false; });
  }

  function refresh(openAfter) {
    raw(sectionUrl('cart-drawer'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fi = doc.querySelector('#CartDrawer'), ci = document.querySelector('#CartDrawer');
        var drawer = document.querySelector('cart-drawer'), fd = doc.querySelector('cart-drawer');
        if (fi && ci) ci.innerHTML = fi.innerHTML;
        if (drawer && fd) drawer.classList.toggle('is-empty', fd.classList.contains('is-empty'));
        if (drawer) {
          var ov = drawer.querySelector('#CartDrawer-Overlay');
          if (ov && typeof drawer.close === 'function') ov.addEventListener('click', drawer.close.bind(drawer));
          if (openAfter && !drawer.classList.contains('active') && typeof drawer.open === 'function') { try { drawer.open(); } catch (e) {} }
        }
      }).catch(function () {});
    raw(sectionUrl('cart-icon-bubble'), { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var f = doc.querySelector('#cart-icon-bubble'), c = document.getElementById('cart-icon-bubble');
        if (f && c) c.innerHTML = f.innerHTML;
      }).catch(function () {});
  }

  function run(openAfter, forceRefresh) {
    if (working) { schedule(openAfter, forceRefresh); return; }
    working = true;
    reconcile().then(function (changed) {
      if (changed || forceRefresh || openAfter) refresh(openAfter);
      working = false;
    }, function () { working = false; });
  }
  function schedule(openAfter, forceRefresh) {
    if (pending) clearTimeout(pending);
    pending = setTimeout(function () { run(openAfter, forceRefresh); }, 250);
  }

  // Watch cart mutations (theme + product-options app) via fetch.
  if (window.fetch) {
    window.fetch = function () {
      var input = arguments[0];
      var url = (input && input.url) ? input.url : (typeof input === 'string' ? input : '');
      var p = origFetch.apply(null, arguments);
      try {
        if (url && /\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
          p.then(function (res) { if (res && res.ok) schedule(url.indexOf('/cart/add') !== -1, true); }).catch(function () {});
        }
      } catch (e) {}
      return p;
    };
  }
  // Watch via XHR too (some apps use it).
  if (window.XMLHttpRequest) {
    var oo = XMLHttpRequest.prototype.open, os = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (m, u) { this.__u = u; return oo.apply(this, arguments); };
    XMLHttpRequest.prototype.send = function () {
      var x = this;
      try {
        if (x.__u && /\/cart\/(add|change|update|clear)(\.js)?/.test(String(x.__u))) {
          x.addEventListener('load', function () { if (x.status >= 200 && x.status < 300) schedule(String(x.__u).indexOf('/cart/add') !== -1, true); });
        }
      } catch (e) {}
      return os.apply(this, arguments);
    };
  }

  // Simple add-to-cart buttons (rush tiers).
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-snkrr-add]');
    if (!b || b.getAttribute('data-snkrr-busy')) return;
    e.preventDefault();
    var id = parseInt(b.getAttribute('data-snkrr-add'), 10);
    if (!id) return;
    b.setAttribute('data-snkrr-busy', '1');
    var lbl = b.querySelector('.snkrr-btn-label');
    if (lbl) lbl.textContent = 'Adding...';
    window.fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }] })
    }).catch(function () { if (lbl) lbl.textContent = 'Try again'; b.removeAttribute('data-snkrr-busy'); });
  }, false);

  // Round-trip sync trigger (gate / fallback button).
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.snkrr-rt-sync')) { e.preventDefault(); schedule(true, true); }
  }, false);

  // Refresh (and reconcile) when the cart icon opens the drawer.
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('#cart-icon-bubble')) schedule(false, true);
  }, true);

  // Expose reconcile so the booking widget can await a correct round-trip
  // tier before handing off to checkout (resolves false when already correct).
  window.snkrrRTReconcile = reconcile;

  // On load, make sure round-trip matches the cart.
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { schedule(false, false); });
  else schedule(false, false);
})();
